import React, { useCallback } from 'react';
import { flexRender } from '@tanstack/react-table';
import styles from './index.module.scss';

const Cell = React.memo(
  ({ cell, cellStyles }: { cell: any; cellStyles: any }) => (
    <td style={cellStyles}>
      <div className={styles.tableWrapperV2__cell}>
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </div>
    </td>
  ),
);

function Row({ row, classNames, onClick, pinnedColumn = '' }) {
  const visibleCells = row.getVisibleCells();
  const getCellStyles = useCallback(
    (idx, cell, total) => {
      const { column } = cell;
      const genericStyles = {
        width: column.getSize(),
        backgroundColor: 'var(--background-flat)',
      };

      if (pinnedColumn === 'left' && idx === 0) {
        return {
          ...genericStyles,
          position: 'sticky',
          left: `${column.getAfter('left')}px`,
          boxShadow:
            'var(--dimensions-none) var(--dimensions-none) 1px var(--dimensions-none) var(--color-alpha-14), var(--dimensions-none) var(--dimensions-100) var(--dimensions-150) var(--dimensions-none) var(--color-alpha-14)',
        };
      }

      if (pinnedColumn === 'right' && idx === total - 1) {
        return {
          ...genericStyles,
          position: 'sticky',
          right: `${column.getAfter('right')}px`,
          boxShadow:
            'var(--dimensions-none) var(--dimensions-none) 1px var(--dimensions-none) var(--color-alpha-14), var(--dimensions-none) var(--dimensions-100) var(--dimensions-150) var(--dimensions-none) var(--color-alpha-14)',
        };
      }

      return genericStyles;
    },
    [pinnedColumn],
  );
  return (
    <tr
      onClick={onClick}
      data-test-id={`table-row-${row.id}`}
      className={classNames}
    >
      {visibleCells.map((cell, idx) => (
        <Cell
          key={cell.id}
          cell={cell}
          cellStyles={getCellStyles(idx, cell, visibleCells.length)}
        />
      ))}
    </tr>
  );
}

export default React.memo(Row);
